export default "__VITE_ASSET__DVSJURv3__"